module.exports = __webpack_public_path__ + "img/logodarck.41fe7d55.png";